import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../../../animations/lottie/spinner.json.js';
import styles from './index.module.scss.js';

const LoaderLogo = () => /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: styles.animation }, /* @__PURE__ */ React.createElement(Lottie, { animationData, autoPlay: true, loop: true })));
LoaderLogo.displayName = "LoaderLogo";

export { LoaderLogo };
//# sourceMappingURL=index.js.map
